import EmailTemplate from 'models/core/claimEmailTemplate/Model.ClaimEmailTemplate';
import { getNextStatus } from 'module/claims/hooks/useClaimsGlobalStore';

type Args = {
  claim: Model.IClaim;
  emailTemplates: EmailTemplate[];
  statusInfo: Model.ClaimStatusInfo;
  currentPermissions: Auth.Permission[];
  isClaimAdmin: boolean;
  hasPermission: boolean;
};

export function getClaimOwnershipRules({
  claim,
  emailTemplates,
  statusInfo,
  currentPermissions,
  isClaimAdmin,
  hasPermission,
}: Args) {
  const { nextStatusList } = getNextStatus(emailTemplates, statusInfo, currentPermissions, claim?.statusCode);

  const showTakeOwnership = !claim?.ownerId && !isClaimAdmin;
  const showChangeOwner = isClaimAdmin || !!claim?.ownerId;

  const canChangeOwnership = !!hasPermission && !!nextStatusList?.length && (showTakeOwnership || showChangeOwner);

  return {
    nextStatusList,
    showTakeOwnership,
    showChangeOwner,
    canChangeOwnership,
  };
}
